/**
* Sets the browser window title to props.title
*/
const Title = props => {
  if (props.title && global && global.document) {
    global.document.title = props.title;
  }
  return null;
};

export default Title;
